var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column homeMenu-container h-100" },
    [
      _c("div", { staticClass: "pt-2 pb-2 text-center" }, [
        _vm.$store.state.authenticated &&
        _vm.$store.state.affiliatedUser.establishments[0].es_avatar
          ? _c("img", {
              staticClass: "company-logo-desktop",
              staticStyle: { "max-width": "200px", width: "100%" },
              attrs: {
                src:
                  "" +
                  this.$config.server_url +
                  _vm.$store.state.affiliatedUser.establishments[0].es_avatar,
                alt: ""
              }
            })
          : _c("img", {
              staticClass: "company-logo-desktop",
              attrs: { src: "/images/logo_emotivi.png", alt: "" }
            })
      ]),
      _c(
        "div",
        {
          staticClass: "d-flex flex-row header-container rounded",
          attrs: { "data-scroll": "0" }
        },
        [
          _vm._m(0),
          _c(
            "div",
            {
              staticClass:
                "flex-grow-1 align-content-center justify-align-center ps-2 "
            },
            [
              _c("div", { staticClass: "fw-bold" }, [_vm._v(_vm._s(_vm.name))]),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline btn-sm p-1",
                    on: { click: _vm.logout }
                  },
                  [
                    _c("icon", {
                      staticClass: "me-1 small-icon",
                      attrs: { name: "power-off" }
                    }),
                    _vm._v(" Deconnexion ")
                  ],
                  1
                )
              ])
            ]
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "flex-grow-1 menu" },
        _vm._l(_vm.items, function(item) {
          return _c("MenuItem", { key: item.i, attrs: { data: item } })
        }),
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "align-content-center avatar-container" }, [
      _c("img", {
        staticClass: "rounded-circle img-fluid",
        attrs: { src: "/images/avatar.png" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }